import { useLayoutEffect, useRef, useState } from "react";

import Checkbox from "./Checkbox";
import FunctionalButton from "./FunctionalButton";

import { ReactComponent as DeleteIcon } from "assets/svgs/Delete.svg";
import { ReactComponent as SortArrowIcon } from "assets/svgs/DownTriangle.svg";

const getAdditionalActionButton = (type = "checkbox", action = () => {}) => {
    switch (type) {
        case "delete":
            return <FunctionalButton icon={<DeleteIcon />} onClick={action} />;

        default:
            return <Checkbox onClick={action} />;
    }
};

const HeaderRow = ({
    columnWidth = 0,
    headerNames = [],
    hasSorting = true,
    additionalActionType = "",
    additionalAction = () => {},
}) => {
    return (
        <div className="flex h-8 w-full  items-center justify-between bg-black80 p-2">
            {headerNames.map((name, id) => (
                <div
                    key={id}
                    className={`group flex  items-center space-x-2 ${
                        hasSorting ? "cursor-pointer" : "cursor-default"
                    }`}
                    style={{
                        width: `${Math.floor(columnWidth - 8 / headerNames.length)}px`,
                    }}
                >
                    <p
                        className={`text-h5 w-fit capitalize text-black40 ${
                            hasSorting && "group-hover:text-white"
                        }`}
                    >
                        {name}
                    </p>
                    {hasSorting && (
                        <SortArrowIcon className="rotate-180 text-black40 group-hover:text-white" />
                    )}
                </div>
            ))}
            {additionalActionType &&
                (additionalActionType === "checkbox" ? (
                    getAdditionalActionButton(additionalActionType, additionalAction)
                ) : (
                    <div className="h-3 w-3"></div>
                ))}
        </div>
    );
};

const DataRow = ({
    columnWidth,
    data = [],
    onClick = () => {},
    additionalActionType = "",
    additionalAction = () => {},
    isSelected = false,
}) => {
    return (
        <div
            className={`group flex h-7 w-full  items-center justify-between py-2 pl-2 hover:bg-primary ${
                isSelected && "bg-primary2"
            }`}
            onClick={onClick}
        >
            {data.map((d, id) => (
                <p
                    key={id}
                    className={`text-h5 text-black40 group-hover:text-white`}
                    style={{
                        width: `${Math.floor(columnWidth - 8 / data.length)}px`,
                    }}
                >
                    {d}
                </p>
            ))}
            {additionalActionType &&
                getAdditionalActionButton(additionalActionType, additionalAction)}
        </div>
    );
};

const Table = ({
    className = "",
    headerNames = [],
    headerHasSorting = true,
    data = [],
    dataRowOnClick = () => {},
    additionalActionType = "",
    headRowAdditionalAction = () => {},
    dataRowAdditionalAction = (data) => {},
    isDataRowSelected = () => {},
}) => {
    const dataRowRef = useRef(null);
    const [columnWidth, setColumnWidth] = useState(0);

    const dataKeyNames = headerNames.reduce((result, current) => {
        current = current.replace(" ", "");
        if (current !== "ARC") current = current.replace(current[0], current[0].toLowerCase());
        result.push(current);
        return result;
    }, []);

    useLayoutEffect(() => {
        setColumnWidth(
            Math.floor(
                dataRowRef.current.scrollWidth /
                    (headerNames.length + (additionalActionType.length > 0 ? 1 : 0))
            )
        );
    }, [additionalActionType.length, headerNames.length]);

    return (
        <div
            className={`flex h-full w-full flex-col items-center justify-start space-y-2 ${className}`}
        >
            <HeaderRow
                columnWidth={columnWidth}
                headerNames={headerNames}
                hasSorting={headerHasSorting}
                additionalActionType={additionalActionType}
                additionalAction={headRowAdditionalAction}
            />
            <div className="scroll-vertical h-full w-full" ref={dataRowRef}>
                {data.map((d, id) => (
                    <DataRow
                        key={id}
                        columnWidth={columnWidth}
                        data={Object.entries(d).reduce((result, [key, value]) => {
                            if (dataKeyNames.includes(key)) result.push(value);
                            return result;
                        }, [])}
                        onClick={() => dataRowOnClick(d)}
                        isSelected={isDataRowSelected(d)}
                        additionalActionType={additionalActionType}
                        additionalAction={(event) => {
                            event.stopPropagation();
                            dataRowAdditionalAction(event, d);
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default Table;
